import React from 'react'
import { SpinnerWhite } from './Spinner'
import { CheckIcon } from '@heroicons/react/24/solid'

const SavedStatusIcon = ({ loadingStatus }) => {
  const savingWords = ['saving', 'loading']
  const savedWords = ['saved', 'complete']
  const saving = savingWords.includes(loadingStatus)
  const saved = savedWords.includes(loadingStatus)
  if (saving) {
    return <SpinnerWhite show={true} className="pl-4" />
  }
  if (saved) {
    return <CheckIcon className="ml-4 size-5 text-white" />
  }
  return null
}
export default SavedStatusIcon
